export default function YoutubeIframe({ videoId }: { videoId: string }) {
  return (
    <iframe
      title="YouTube video player"
      width="100%"
      height="432"
      src={`https://www.youtube.com/embed/${videoId}?rel=0`}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
}
